import type { PublicProfile } from "./ProfileAvatar";
const profiles = new Map<
  string,
  { expires: number; result: Promise<PublicProfile | null> }
>();
// Public display data only. Profile lookup never verifies authentication.
export function publicProfile(did: string): Promise<PublicProfile | null> {
  if (!/^did:[a-z0-9]+:[A-Za-z0-9._:%-]+$/.test(did))
    return Promise.resolve(null);
  const cached = profiles.get(did);
  if (cached && cached.expires > Date.now()) return cached.result;
  const result = lookup(did);
  if (profiles.size >= 100) profiles.delete(profiles.keys().next().value!);
  profiles.set(did, { expires: Date.now() + 300000, result });
  return result;
}
async function lookup(did: string): Promise<PublicProfile | null> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 5000);
  try {
    const url = new URL(
      "https://public.api.bsky.app/xrpc/app.bsky.actor.getProfile",
    );
    url.searchParams.set("actor", did);
    const response = await fetch(url, {
      credentials: "omit",
      signal: controller.signal,
      redirect: "error",
    });
    if (!response.ok) return null;
    const profile = await response.json();
    if (
      profile?.did !== did ||
      typeof profile.handle !== "string" ||
      profile.handle === "handle.invalid"
    )
      return null;
    return {
      did,
      handle: profile.handle,
      displayName:
        typeof profile.displayName === "string"
          ? profile.displayName
          : undefined,
      avatar: typeof profile.avatar === "string" ? profile.avatar : undefined,
    };
  } catch {
    return null;
  } finally {
    clearTimeout(timer);
  }
}
